export const DEFAULT_TOOLTIP = 'text will be here soon';
